import * as ElementUIModule from 'element-ui/lib/element-ui.common.js'

const ElementUI =
  (ElementUIModule && (ElementUIModule.default || ElementUIModule)) ||
  (typeof globalThis !== 'undefined' && globalThis.ElementUI) ||
  (typeof window !== 'undefined' && window.ElementUI) ||
  null

if (typeof globalThis !== 'undefined' && ElementUI) {
  globalThis.ElementUI = ElementUI
} else if (typeof window !== 'undefined' && ElementUI) {
  window.ElementUI = ElementUI
}

export default ElementUI
export { ElementUI }
